import React, { useEffect, useState } from 'react'
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Badge, Box } from '@mui/material';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getMode } from '../../utils/app.utils';

export default function TabComponent({ dataTabs }) {
    const params = useParams()
    const [tab, setTab] = useState([])
    const location = useLocation()
    const navigate = useNavigate()
    const { noti } = useSelector(state => state.noti)
    const { profile } = useSelector(state => state.profile)
    const mode = getMode()
    const [value, setValue] = useState('');
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    useEffect(() => {
        setValue(location.pathname.replace(`/${location.pathname.split('/')[3]}`, ''));
    }, [location.pathname])
    useEffect(() => {
        if (profile) {
            if (location.pathname.includes('/stock') === true) {
                if (mode !== 'online') {
                    setTab(dataTabs.filter(x => x.title === 'รับเมล็ดพันธุ์ดี' || x.title === 'เมล็ดพันธุ์คงคลัง'))
                }
                if (mode === 'online' && profile?.BranchNo?.BranchNo !== '00') {
                    setTab(dataTabs.filter(x => x.title !== 'สำรองเมล็ดพันธุ์ (ส่วนกลาง)' && x.title !== 'ปรับปรุงยอด'))
                }
                if (mode === 'online' && profile?.BranchNo?.BranchNo === '00') {
                    setTab(dataTabs)
                }
            }
            else if (location.pathname.includes('/setting') === true) {
                if (mode !== 'online' || profile?.BranchNo?.BranchNo !== '00') {
                    setTab(dataTabs.filter(x => x.title === 'โรงเก็บ' || x.title === 'เปลี่ยนรหัสผ่าน'))
                }

                if (mode === 'online' && profile?.BranchNo?.BranchNo === '00') {
                    setTab(dataTabs)
                }
            }
            else if (location.pathname.includes('/sale') === true) {
                if (mode !== 'online' || profile?.BranchNo?.BranchNo !== '00') {
                    setTab(dataTabs.filter(x => x.title !== 'ตั้งราคาเฉพาะกิจ'))
                }
                if (mode === 'online' && profile?.BranchNo?.BranchNo === '00') {
                    setTab(dataTabs)

                }
            }
            else if (location.pathname.includes('/materials') === true) {
                if (mode !== 'online') {
                    setTab(dataTabs.filter(x => x.title !== 'โอนวัสดุ' && x.title !== 'ยืมวัสดุ' && x.title !== 'คืนวัสดุ'))
                }
                else {
                    setTab(dataTabs)

                }
            }

            else {
                setTab(dataTabs)
            }

        }
    }, [profile, dataTabs])
    // const TabPanelComponent = ({ value, i, page }) => {
    //     return (
    //         <>
    //             {value === location.pathname && (
    //                 <Box value={value} index={i} sx={{ margin: "20px 0px" }}>
    //                     {page}
    //                 </Box>
    //             )
    //             }
    //         </>
    //     )
    // }

    return (
        <>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs
                    variant="scrollable"
                    scrollButtons="auto"
                    value={value} onChange={handleChange} sx={{
                        width: "100%", '.MuiTabs-indicator': {
                            background: '#ffa101'
                        }
                    }}>
                    {
                        tab?.filter((y) => y?.Permit).map((x) => <Tab value={x?.url} label={x.title} icon={x?.url === '/stock/stock-transfer' && noti?.NewTransferIn > 0 ? <div style={{
                            width: '22px',
                            height: '22px',
                            position: 'absolute',
                            top: '4px',
                            right: '0',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: 'red',
                            color: '#fff',
                            fontSize: '12px',
                            borderRadius: '50%'
                        }}>{noti?.NewTransferIn}</div> : x?.url === '/stock/reserve' && noti?.NewReserveCenter > 0 ? <div style={{
                            width: '22px',
                            height: '22px',
                            position: 'absolute',
                            top: '4px',
                            right: '0',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: 'red',
                            color: '#fff',
                            fontSize: '12px',
                            borderRadius: '50%'
                        }}>{noti?.NewReserveCenter}</div> : x?.url === '/agent/agent-list' && noti?.NewAgentRequest > 0 ? <div style={{
                            width: '22px',
                            height: '22px',
                            position: 'absolute',
                            top: '4px',
                            right: '0',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: 'red',
                            color: '#fff',
                            fontSize: '12px',
                            borderRadius: '50%'
                        }}>{noti?.NewAgentRequest}</div> : ''} onClick={() => navigate(x?.url)} sx={{
                            fontSize: '1rem', minHeight: '0px !important', '&.Mui-selected': {
                                color: '#000'
                            },
                        }} />)
                    }

                </Tabs>

            </Box>
            {/* {
                params.id || location.pathname.includes('add') ? <Outlet /> : dataTabs.filter((y) => y.Permit).map((x, i) => <TabPanelComponent value={x?.url} i={i} page={x?.page} />)
            } */}
            {/* <Outlet /> */}
        </>
    )
}


